import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { FxRate } from '@/api/types';
import type { Decimal } from '@/lib/format/decimal';

export const fxKeys = { latest: ['fx', 'latest'] as const };

export const fxQuery = () =>
  queryOptions({
    queryKey: fxKeys.latest,
    queryFn: ({ signal }) => api<FxRate>('/fx/current', { signal }),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });

export function useRefreshFx() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => api<FxRate>('/fx/refresh', { method: 'POST' }),
    onSuccess: (rate) => client.setQueryData(fxKeys.latest, rate),
  });
}

export function useManualFx() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: { sale: Decimal; publishedAt: string; reason: string; acknowledgeDeviation?: boolean }) =>
      api<FxRate>('/fx/manual', { body }),
    onSuccess: (rate) => client.setQueryData(fxKeys.latest, rate),
  });
}

export function fxSourceLabel(source: string): string {
  if (source === 'AMBITO_OFICIAL_VENTA') return 'Ámbito · oficial venta';
  if (source === 'AMBITO_BLUE_VENTA') return 'Ámbito · blue venta (anterior)';
  if (source === 'AMBITO_PENDING_REVIEW') return 'Ámbito · pendiente de revisión';
  if (source === 'MANUAL') return 'Carga manual';
  if (source === 'HISTORICAL_FIXTURE') return 'Histórica (Excel)';
  return source;
}
